import { Typography as MuiTypography } from '@mui/material';
import { display, spacing, typography } from '@mui/system';
import styled from 'styled-components';

import { colorPalette, colorTokens } from '../variables';

// Flat map of every textColor token used across the app → resolved hex value.
// These strings are not valid CSS on their own; without this lookup they silently
// produce `color: <token-name>` which browsers ignore.
const textColorMap: Record<string, string> = {
  text: colorPalette.neutral10,
  primaryText: colorPalette.neutral10,
  secondaryText: colorPalette.neutralVariant40,
  'text-light': colorPalette.neutralVariant40,
  primary: colorTokens.primary.main,
  secondary: colorPalette.navy30,
  'secondary-hover': colorPalette.navy40,
  'secondary-active': colorPalette.navy20,
  'link-active': colorPalette.navy20,
  error: colorTokens.error.main,
  success: colorTokens.success.main,
  'warning-dark': colorTokens.warning.dark,
  'info-main': colorTokens.info.main,
};

const resolveColor = (token?: string): string => {
  if (!token) {
    return colorTokens.text.dark;
  }

  return textColorMap[token] ?? colorPalette[token] ?? token;
};

// Adding spacing and display to Text component
export const StyledText = styled(({ textColor, ...props }) => <MuiTypography {...props} />)`
  ${typography};
  ${spacing};
  ${display};
  color: ${({ textColor }) => resolveColor(textColor)};
`;
